import React from 'react'

import linkifyStr from 'linkify-string'

import Theme from '@theme'

interface IProps {
  value: string
  color?: string
  preserveLineBreaks?: boolean
}

const LinkifiedString: React.FC<IProps> = ({
  value,
  color = Theme.grey900Color,
  preserveLineBreaks = false,
}) => {
  if (!value) {
    return null
  }
  return (
    <p
      style={preserveLineBreaks ? { whiteSpace: 'pre-line' } : undefined}
      dangerouslySetInnerHTML={{
        __html: linkifyStr(value, {
          tagName: 'a',
          target: {
            url: '_blank',
          },
          attributes: {
            style: `color: ${color}`,
          },
        }),
      }}
    />
  )
}

export default LinkifiedString
